import { yellowIcon } from '../DetailComponents/utils';

export const semaforoConfig = {
  id: 'semaforo',
  label: 'Semáforos',
  regex: /semaforo|semáforo|semafor|semáfor|foro\s+vehicular|peatonal/i,
  autoHeatmap: false,
  icon: yellowIcon,
  jsonFields: [
    { key: 'tipo_semaforo', label: 'Tipo Semáforo' },
    { key: 'estado', label: 'Estado' },
    { key: 'colores', label: 'Colores' },
    { key: 'altura', label: 'Altura (m)' },
    { key: 'funciona', label: 'Funciona', type: 'bool' },
    { key: 'dano_estructural', label: 'Daño Estructural', type: 'bool' },
  ],
  renderExtraInfo: () => null,
  subFilters: [],
  calculatePriority: () => 'Baja',
  calculateCompany: () => 'N/A',
  summaryConfig: {
    showCompanyKPI: false,
    showPriorityKPI: false,
    mainChart: 'streets'
  },
  hasPriority: false,
  hasCompany: false
};
